// End-of-wave bonus: (unused missiles x5 + surviving cities x100) x multiplier.

import type { GameState, BonusBreakdown } from '../state/types';
import {
  BONUS_PER_SURVIVING_CITY,
  BONUS_PER_UNUSED_MISSILE,
} from '../constants';

export function computeWaveBonus(state: GameState): BonusBreakdown {
  const unusedMissiles = state.bases.reduce(
    (n, b) => n + (b.alive ? b.ammo : 0),
    0,
  );
  const survivingCities = state.cities.filter((c) => c.alive).length;
  const multiplier = state.scoreMultiplier;
  const points =
    (unusedMissiles * BONUS_PER_UNUSED_MISSILE +
      survivingCities * BONUS_PER_SURVIVING_CITY) *
    multiplier;
  return { unusedMissiles, survivingCities, multiplier, points };
}
